import React from 'react';

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 font-sans">
      <div className="max-w-3xl mx-auto bg-white p-6 sm:p-10 shadow-sm border border-gray-200">
        
        {/* Page Header */}
        <div className="border-b border-gray-200 pb-6 mb-8 text-center sm:text-left">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            Terms & Conditions
          </h1>
          <p className="text-xs sm:text-sm text-gray-500 mt-2">
            Last Updated: {new Date().toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}
          </p>
        </div>

        {/* Introduction / Terms of Use */}
        <div className="mb-8">
          <h2 className="text-base font-bold text-gray-900 mb-2">
            Terms of Use
          </h2>
          <p className="text-sm text-gray-600 leading-relaxed">
            By accessing or using this landing page, you acknowledge and agree to abide by the following terms and conditions:
          </p>
        </div>

        {/* Policy Sections */}
        <div className="space-y-6">
          
          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Intellectual Property Rights
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              All content, images, logos, and materials displayed on this landing page are the exclusive property of the real estate company or its licensors and are safeguarded by intellectual property laws. Unauthorized copying, modification, distribution, or usage of any content is strictly prohibited without prior written consent.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Property Information Disclaimer
            </h2>
            <p className="text-sm text-gray-600 line-height-relaxed text-gray-600 leading-relaxed">
              The information provided on this landing page, including property descriptions, prices, availability, and other details, is subject to change without prior notice. The real estate company shall not be held accountable for any inaccuracies or omissions in the information provided.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              User Responsibilities
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Users are responsible for furnishing accurate and current information when submitting inquiries or requests through this landing page. Additionally, users agree not to engage in unlawful or detrimental activities, such as hacking, spamming, or transmitting malicious software.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Privacy and Data Handling
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              This real estate company collects, stores, and utilizes user data in compliance with applicable privacy laws. The landing page may employ third-party services or tracking technologies, like cookies or analytics tools, for which detailed information can be found in the privacy policy.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Disclaimer of Liability
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Under no circumstances shall the real estate company be liable for damages, losses, or injuries arising from the use of this landing page or reliance on the provided information. This includes, but is not limited to, financial losses, property damage, or any direct or indirect damages.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Third-Party Website Links
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Links provided on this landing page to external websites or resources do not signify endorsement or assumption of responsibility for their content, privacy practices, or availability by the real estate company.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Modification of Terms
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              The real estate company reserves the right to revise or modify these terms and conditions at any time without prior notice. Users are encouraged to periodically review the terms for updates.
            </p>
          </section>

          <section>
            <h2 className="text-base font-bold text-gray-900 mb-2">
              Governing Law and Jurisdiction
            </h2>
            <p className="text-sm text-gray-600 leading-relaxed">
              Any legal disputes arising from the use of this landing page shall be resolved within the specified jurisdiction and governed by the applicable laws pertaining to that jurisdiction.
            </p>
          </section>

        </div>

        {/* Home Navigation Route */}
        <div className="mt-10 pt-6 border-t border-gray-200 text-center">
          <a 
            href="/" 
            className="text-xs sm:text-sm text-[#007BFF] hover:underline font-medium"
          >
            ← Back to Homepage
          </a>
        </div>

      </div>
    </div>
  );
}